import { useState } from 'react';

import { getText } from '../../services/localization.js'

import { Header } from '../Header';
import { Footer } from '../Footer';
import { Modal } from '../Modal/Modal.js';

import { pivot } from '../../assets/data/pivot.js';

import styles from './NewItems.module.css';

export const NewItems = () => {

  const [modalData, setModalData] = useState(null);

  return (
    <div>
      <Header />
      <div className={styles.page}>
        <div className='container'>
          <div className={styles.newWrapper}>
            <h3>Pivot Doors</h3>
            <p>{getText('وهو باب امان بتصميم متفردَ صنع خصيصا ليتناسب مع التصاميم الحديثة للفلل والشقق الخاصة.', 'A unique security door model which manufactured specially to meet the modern design for villas and apartments.')}</p>
          </div>
          <div className={styles.content}>
            <video controls autoPlay muted loop className={styles.video} src='https://storage.googleapis.com/door-assets/pivot/pivot_video.mp4'></video>
            <div className={styles.cardsWrapper}>
              {pivot.assets.map(item => <div key={item.id} className={styles.pivotCard} style={{backgroundImage: `url(${item.img})`}} onClick={() => setModalData(item)}></div>)}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {!!modalData && <Modal data={modalData} setModalData={setModalData}/>}
    </div>
  );
};
